import { create } from 'zustand'

export type ToastVariant = 'error' | 'success'

export type Toast = {
  id: string
  message: string
  variant: ToastVariant
}

const MAX_TOASTS = 3
const DISMISS_MS = 4000

type ToastState = {
  toasts: Toast[]
  addToast: (message: string, variant: ToastVariant) => void
  removeToast: (id: string) => void
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  addToast: (message, variant) => {
    const id = crypto.randomUUID()
    const toast: Toast = { id, message, variant }

    set((state) => ({
      toasts: [...state.toasts, toast].slice(-MAX_TOASTS),
    }))

    setTimeout(() => {
      get().removeToast(id)
    }, DISMISS_MS)
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }))
  },
}))
